import { Component } from '@angular/core';
import { LoginService } from 'app/services/login/login.service';

@Component({
  selector: 'app-factura-cc',
  templateUrl: './facturacc.component.html',
  styleUrls: ['./facturacc.component.scss']
})
export class FacturaccComponent  {

  constructor(private loginService:LoginService) { }



  clickGuard(){
    this.loginService.clickGuard = true;
 }


}
